import {
  HHChip,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../utils/bills-utils';
import { IDiscount } from '../../../utils/discount-utils';

interface PackageDiscountSummaryProps {
  discounts: IDiscount[];
}

export const PackageDiscountSummary = ({
  discounts,
}: PackageDiscountSummaryProps): JSX.Element => {
  const uniqueDiscountTypes = [...new Set(discounts.map(d => d.discountType))];

  return (
    <HHStack gap={1}>
      <HHTypography hhVariant="variant-bypass" color="text.secondary">
        Discounts
      </HHTypography>
      <HHStack direction="row" gap={1} flexWrap="wrap">
        {uniqueDiscountTypes.map(discountType => (
          <HHChip
            key={discountType}
            hhVariant="variant-bypass"
            size="small"
            color="default"
            label={capitalizeFirstLetterAndSpaceSnakeString(discountType)}
          />
        ))}
      </HHStack>
    </HHStack>
  );
};
